import type { PageContent } from "../types";

export const p_mobile_and_core_web_vitals_in_2023: PageContent = {
  slug: "mobile-and-core-web-vitals-in-2023",
  title: `Mobile and Core Web Vitals in 2023 | Phil Carr SEO Consultant`,
  description: `Google’s focus on user experience reached new heights in 2023, particularly with the rollout of the Interaction to Next Paint (INP) metric. INP measures how…`,
  date: "",
  lastUpdated: "2026-06-14",
  body: `# Mobile and Core Web Vitals in 2023

![Mobile and Core Web Vitals in 2023 featured image](/images/blog/generated/mobile-and-core-web-vitals-in-2023.jpg)

**Published:** June 15, 2023

## Keeping Up with User Experience Metrics

Google’s focus on user experience reached new heights in 2023, particularly with the rollout of the Interaction to Next Paint (INP) metric. INP measures how quickly a page responds to user interactions, such as tapping a button or filling out a form.

It is an evolution of First Input Delay and emphasises the importance of responsive, intuitive design. Sites that provide smooth interactions and fast load times see improved visibility in search results, while those with sluggish interfaces risk losing ground.

## Mobile‑First Remains Standard

With mobile devices accounting for the majority of web traffic, Google’s mobile‑first indexing continues to be the baseline for ranking and indexing. This means the mobile version of your website is the one that counts most.

Pages must be designed for smaller screens, with easily readable text, tappable buttons, and minimal intrusion from pop‑ups. Core Web Vitals—Largest Contentful Paint, Cumulative Layout Shift, and INP—should remain well within recommended thresholds.

Tools such as PageSpeed Insights and the Core Web Vitals report in Search Console can help identify performance issues.

## Action Steps

Audit your site for responsiveness by testing on various devices and connection speeds. Optimise images and scripts to reduce loading times, and remove or delay non‑essential elements.

Use lazy loading for off‑screen content, compress assets, and implement caching. Ensure that all interactive elements respond quickly and predictably.

Remember, user experience is not only a ranking factor—it also directly affects conversion rates and customer satisfaction.

## SEO Takeaways and Next Steps

User experience and mobile optimisation have never been more critical. By prioritising Core Web Vitals and responsive design, you can boost both your rankings and the perception of your brand.

Need help improving site performance? contact me at info@phil‑carr.co.uk or 01226 697 325 for a tailored audit.

If you need help with your SEO strategy, get in touch by emailing [info@phil-carr.co.uk](mailto:info@phil-carr.co.uk) or calling 01226 697 325.

## Key Takeaways

- **Keeping Up with User Experience Metrics:** Google’s focus on user experience reached new heights in 2023, particularly with the rollout of the Interaction to Next Paint (INP) metric.
- **Mobile‑First Remains Standard:** With mobile devices accounting for the majority of web traffic, Google’s mobile‑first indexing continues to be the baseline for ranking and indexing.
- **Action Steps:** Audit your site for responsiveness by testing on various devices and connection speeds.

## Update — June 2026

Google confirmed another core update in June 2026, and the pattern I flagged here has held — sites with thin, AI-generated pages have taken the sharpest hits. If you're re-reading this after a ranking drop, the priority order still stands: audit intent match first, then depth, then internal linking.

## About the author

Phil Carr is an SEO consultant and web strategist focused on helping businesses
grow through technical optimisation, content strategy, and data-driven decision making. His
work combines hands-on experience with ongoing research into algorithm updates and emerging
search trends.

[Read Phil’s bio](/#authorModal)

## Other News Articles

[![2024 Algorithm Updates – Navigating a Year of Core Changes and Spam Crackdowns featured image](/images/blog/generated/2024-algorithm-updates-navigating-a-year-of-core-changes-and-spam-crackdowns.jpg)](/blog/2024-algorithm-updates-navigating-a-year-of-core-changes-and-spam-crackdowns)

### [2024 Algorithm Updates – Navigating a Year of Core Changes and Spam Crackdowns](/blog/2024-algorithm-updates-navigating-a-year-of-core-changes-and-spam-crackdowns)

[![2023 SEO Lessons and Forward View featured image](/images/blog/generated/2023-seo-lessons-and-forward-view.jpg)](/blog/2023-seo-lessons-and-forward-view)

### [2023 SEO Lessons and Forward View](/blog/2023-seo-lessons-and-forward-view)

[![A Practical Plan for AI-Driven Search – A Ninety Day Playbook featured image](/images/blog/generated/a-practical-plan-for-ai-driven-search-a-ninety-day-playbook.jpg)](/blog/a-practical-plan-for-ai-driven-search-a-ninety-day-playbook)

### [A Practical Plan for AI-Driven Search – A Ninety Day Playbook](/blog/a-practical-plan-for-ai-driven-search-a-ninety-day-playbook)

[![Looking Ahead: Lessons from 2024 for the Future featured image](/images/blog/generated/looking-ahead-lessons-from-2024-for-the-future.jpg)](/blog/looking-ahead-lessons-from-2024-for-the-future)

### [Looking Ahead: Lessons from 2024 for the Future](/blog/looking-ahead-lessons-from-2024-for-the-future)

We use cookies to improve your experience, analyse site traffic, and understand how you interact with
our content. Read our [cookie policy](/cookies) to learn more.

Reject optionalAccept cookies [Privacy policy](/privacy-policy)

reCAPTCHA

Recaptcha requires verification.

protected by **reCAPTCHA**`,
};
